import { capabilityDecisionStatuses } from '@customerio/hydra-copilot';
import type { CopilotStatefulToolCall } from '@customerio/hydra-copilot';

// Single source of decision statuses so the readers can't drift — the session
// layer resolves denials from the same list when deciding a tool call's status.
export function capabilityStatuses(response: CopilotStatefulToolCall['response']): string[] {
  return capabilityDecisionStatuses(response);
}
